import * as React from 'react'

import '../styles/DrawerItem.scss'

interface DrawerProps<T> {
    isSelected: boolean
    title?: string
    data?: T
    icon?: any
    onClick?: (data?: T) => void
}

export class DrawerItem<T> extends React.Component<DrawerProps<T>, {}> {
    constructor(props: any) {
        super(props)

    }

    onClick = (event: any) => {
        if (this.props.onClick) {
            this.props.onClick(this.props.data)
        }
        event.stopPropagation()
    }

    onKeyBoardBtnPress = (event:any) => {
        if(event.key == ' ' || event.key == 'Enter')
        {
            if (this.props.onClick) {
                this.props.onClick(this.props.data)
                event.stopPropagation()
            }
        }
    }

    getIcon(filename: string) {
        return require(`../styles/icons/sidemenu/${filename}`)
    }
    
    render() {
        let className = 'drawer-item'
        if (this.props.isSelected) {
            className += ' selected'
        }
        return (
            <div
                className={className}
                tabIndex={0}
                onKeyPress={this.onKeyBoardBtnPress}
                onClick={this.onClick}
            >
                {this.props.icon ? <img className={'drawer-item-icon'} src={this.getIcon(this.props.icon)} /> : ''}
                {this.props.title ? <span className={'drawer-item-title'}>{this.props.title}</span> :
                    <span className={'drawer-item-title'}>{this.props.children}</span>}
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/DrawerItem.tsx